import type { TFunction } from 'i18next'

type CallQuota = { remainingSeconds: number; limitSeconds: number; plan: 'trial' | 'pro' }

// Free users and trials out of minutes get the upsell; Pro users out of
// this month's minutes just learn when they come back.
export function callGate(isPro: boolean, quota: CallQuota | undefined): 'upgrade' | 'out' | null {
  if (!isPro) return 'upgrade'
  if (!quota || Math.ceil(quota.remainingSeconds / 60) > 0) return null
  return quota.plan === 'trial' ? 'upgrade' : 'out'
}

export function callsOutMessage(t: TFunction, language: string, quota: CallQuota | undefined) {
  const now = new Date()
  const date = new Intl.DateTimeFormat(language, { month: 'short', day: 'numeric' }).format(
    new Date(now.getFullYear(), now.getMonth() + 1, 1),
  )
  return t('coach.callsOutPro', { minutes: Math.round((quota?.limitSeconds ?? 0) / 60), date })
}
